import React, {useRef, useState, useEffect } from 'react';
import { Stack, Box, Typography, InputLabel, Input, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BackgroundImage from '../assets/background.png';
import StockholemImage from '../assets/Stockholm.png';
import { FormProvider } from 'website/components/Form/FormProvider';
import { useForm } from 'react-hook-form';
import useYupValidationResolver from 'hook/useYupValidationResolver';
import { contactUsSchema } from '../validation';
import { TurnstileWidget } from 'components/TurnstileWidget'; // Added

const getDefaultValues = () => ({
  name: '',
  email: '',
  phone: '',
  message: '',
});

export const ContactUsForm = ({onSubmit}) => {
  const { t } = useTranslation();
  const [turnstileToken, setTurnstileToken] = useState(''); // Added
  const methods = useForm({
    mode: "onSubmit",
    resolver: useYupValidationResolver(contactUsSchema),
    defaultValues: getDefaultValues(),
  });

  const {
    formState: { errors },
  } = methods; 

  const handleChange = (input) => (e) => {
    methods.setValue(input, e.target.value);
  }

  const absoluteStackRef = useRef(null);
  const [yOffset, setYOffset] = useState(0);
  const [xOffset, setXOffset] = useState(0);

  useEffect(() => {
    function updateOffset() {
      if (absoluteStackRef.current) {
        setYOffset(absoluteStackRef.current.offsetHeight);
        setXOffset(absoluteStackRef.current.offsetWidth);
      }
    }

    updateOffset();
    window.addEventListener('resize', updateOffset);

    return () => {
      window.removeEventListener('resize', updateOffset);
    };
  }, [absoluteStackRef]);

  return (
      <Box sx={{
        "& .MuiTypography-body2": {
          color: "text.black",
          fontSize: {xs: '1rem', md: '1.125rem'},
          fontWeight: 400,
          lineHeight: {xs: 1.5, md: 1.75},
        },
        mb: 5,
        position: "relative",
        width: 1,
        display: "flex",
        alignSelf: "center",
        maxWidth: "1200px",
      }}>
        <Stack flex={1} direction="column" width="100%" gap={{xs: 3, md: 10}}>
          <Stack
            display={"flex"}
            sx={{
              position: "relative",
              ml: "-50vw",
              left: "50%",
              width: "100vw",
              minHeight: 300,
              height: {xs: 1, md: yOffset},
            }}
          >
            <img
              className="small-logo"
              src={BackgroundImage}
              alt={'BackgroundImage'}
              loading="lazy"
              style={{
                width: "100%",
                height: yOffset,
                minHeight: 300,
                objectFit: "cover",
              }}
            />
            <Stack
              display={"flex"}
              width={1}
              maxWidth={{xs:664, md: 1200}}
              direction={{xs: "column", md : "row"}}
              gap={{xs: 3, md: 9}}
              pt={5.625}
              ref={absoluteStackRef}
              sx={{
                position: "absolute",
                left: {xs: `calc((100vw - ${xOffset}px)/2)`, md: "50%"},
                transform: {xs: "none", md: "translateX(-50%)"},
                boxSizing: 'border-box',
                px: {xs: 4, md: 6},
                height: "auto",
              }}
            >
              <Stack direction="column" flex={1} gap={2}>
                <Typography variant="h5" color={"primary.light"} fontWeight={600} lineHeight={"normal"}>
                  {t('website:contact.hero.eyebrow')}
                </Typography>
                <Typography variant="h1" fontSize={"2.5rem"} fontWeight={{xs: 600, md: 700}}>
                  {t('website:contact.hero.heading')}
                </Typography>
                <Typography variant='body1' lineHeight={1.5} fontSize={{xs: '1rem', md: '1.125rem'}} fontWeight={400} paddingBottom={{xs:0, md: 3}}>
                  {t('website:contact.hero.description')}
                </Typography>
              </Stack>
              <Stack direction={{xs: "column", md : "row"}} flex={1} justifyContent={"space-between"} flexWrap={"wrap"} alignContent={{xs: "flex-start", md: "center"}} pt={{xs: 4, md: 0}} gap={5}>
                {/* <Stack direction="column" gap={3.375} flex={1}>
                  <Typography variant='h5' lineHeight={"normal"} fontWeight={600} color={"text.custom"} fontSize={{xs: '1.125rem', md: '1.5rem'}}>
                    Number

                  </Typography>
                  <Stack direction={"column"} gap={2} marginBottom={{xs: 0, md: 3}}>
                    <Stack direction={{xs: "row", md: "column"}} gap={{xs: 1, md: 0}}>
                      <Typography variant='body2'>
                        Operations:
                      </Typography>
                      <Typography variant='body2'>
                        +46 702 28 51 68
                      </Typography>
                    </Stack>
                    <Stack direction={{xs: "row", md: "column"}} gap={{xs: 1, md: 0}}>
                      <Typography variant='body2'>
                        Sales:
                      </Typography>
                      <Typography variant='body2'>
                        +46 704 99 35 27
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack> */}
                <Stack direction="column" gap={3.375} pb={{xs:5, md: 0}} flex={1}>
                  <Typography variant='h5' lineHeight={"normal"} fontWeight={600} color={"text.custom"} fontSize={{xs: '1.125rem', md: '1.5rem'}}>
                    {t('website:contact.hero.email.heading')}
                  </Typography>
                  <Stack direction={"column"} gap={2}>
                    <Typography variant='body2'>
                      {t('website:contact.hero.email.address')}
                    </Typography>
                    <Typography variant='body2'>
                      {t('website:contact.hero.email.hours')}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          <Stack
            flex={1}
            direction={{xs: "column", md: "row"}}
            gap={9}
            width={"100vw"}
            maxWidth={{xs:664, md: 1200}}
            px={{xs: 4, md: 6}}
            boxSizing={"border-box"}
            alignSelf={"center"}
            display={"flex"}
          >
            <Stack flex={1} direction="column" gap={2}>
              <FormProvider methods={methods} onSubmit={(data) => onSubmit({ ...data, turnstileToken })}> {/* Modified */}
                <Stack
                  gap={4}
                  sx={{
                    '& label': {
                      fontSize: "1.125rem",
                      fontWeight: 400,
                      lineHeight: 1.75,
                      color: "text.black"
                    },
                    '& input': {
                      height: 15,
                      px: '2px!important',
                      pt: "0!important",
                      pb: "7px!important",
                      '&:focus': {
                        outline: 'none',
                      },
                      '&:-internal-autofill-selected, &:-webkit-autofill': {
                        backgroundColor: 'transparent!important',
                        '-webkit-box-shadow': '0 0 0 1000px white inset!important',
                        transition: 'background-color 5000s ease-in-out 0s!important',
                      }
                    },
                    '& textarea': {
                      px: '2px!important',
                      pt: "0!important",
                      pb: "7px!important",
                    }
                  }}
                >
                  <Box>
                    <InputLabel htmlFor="name">
                      {t('website:contact.form.nameLabel')}
                    </InputLabel>
                    <Input
                      id="name"
                      name="name"
                      autoComplete="name"
                      fullWidth
                      onChange={handleChange("name")}
                      error={!!errors.name}
                      aria-describedby="name-error-text"
                    />
                    {errors.name && (
                      <Typography id="name-error-text" style={{ color: 'red' }} fontWeight={500}>
                        {errors.name?.message}
                      </Typography>
                    )}
                  </Box>
                  <Box>
                    <InputLabel htmlFor="email">
                      {t('website:contact.form.emailLabel')}
                    </InputLabel>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      inputProps={{ autoCapitalize: 'none', autoCorrect: 'off', spellCheck: false }}
                      fullWidth
                      onChange={handleChange("email")}
                      error={!!errors.email}
                      aria-describedby="email-error-text"
                    />
                    {errors.email && (
                      <Typography id="email-error-text" style={{ color: 'red' }} fontWeight={500}>
                        {errors.email?.message}
                      </Typography>
                    )}
                  </Box>
                  <Box>
                    <InputLabel htmlFor="phone">
                      {t('website:contact.form.phoneLabel')}
                    </InputLabel>
                    <Input
                      id="phone"
                      name="phone"
                      type="tel"
                      autoComplete="tel"
                      fullWidth
                      onChange={handleChange("phone")}
                    />
                  </Box>
                  <Box>
                    <InputLabel htmlFor="message">
                      {t('website:contact.form.messageLabel')}
                    </InputLabel>
                    <Input
                      id="message"
                      name="message"
                      fullWidth
                      onChange={handleChange("message")}
                      multiline
                      minRows={3}
                      maxRows={3}
                      error={!!errors.email}
                      aria-describedby="message-error-text"
                    />
                    {errors.message && (
                      <Typography id="message-error-text" style={{ color: 'red' }} fontWeight={500}>
                        {errors.message?.message}
                      </Typography>
                    )}
                  </Box>
                  <TurnstileWidget onSuccess={setTurnstileToken} />
                  <Button
                    size="large"
                    variant="contained"
                    type="submit"
                    disabled={!turnstileToken} // Modified disabled prop
                    sx={{
                      backgroundColor: "#62A7B7",
                      '&:hover': {
                        backgroundColor: "#62A7B7",
                      },
                      minWidth: 217,
                      whiteSpace: 'nowrap',
                      alignSelf: {xs: "center", md: "start"},
                    }}
                  >
                    {t('website:contact.form.submitButton')}
                  </Button>
                </Stack>
              </FormProvider>
            </Stack>
            <Stack flex={1} direction="column" gap={2}>
              <Box mb={{xs:0, md:7}}>
                <img
                  className="small-logo"
                  src={StockholemImage}
                  alt={'StockholemImage'}
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Box>
  );
};
